import type { Instrument } from "@/utils/types";

const defaultPreferences = {
  x_instrument: "guitar",
  default_artist: "",
  updated_timestamp: 0,
};
export default defaultPreferences;

export const displayPreferenceMap: {
  Chords: {
    x_instrument: {
      label: string;
      options: Array<{
        label: string;
        value: Instrument;
      }>;
    };
  };
  General: {
    default_artist: {
      label: string;
    };
  };
} = {
  Chords: {
    x_instrument: {
      label: "Instrument",
      options: [
        { label: "Guitar", value: "guitar" },
        { label: "Ukulele", value: "uke" },
        { label: "Uke (Baritone)", value: "ukebaritone" },
        { label: "Banjo", value: "banjo" },
        { label: "Mandolin", value: "mandolin" },
      ],
    },
  },
  General: {
    default_artist: {
      label: "Default Artist",
    },
  },
};
